import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { ArrowRightIcon } from '@mui/x-date-pickers-pro';

import useAuth from '../../auth/useAuth';

const OrganizationListItem = ({
  orgName,
  orgId,
  handleChangeOrg,
}: {
  orgName: string;
  orgId: string;
  handleChangeOrg: () => Promise<void>;
}) => {
  const { isAuthenticated, getUser } = useAuth();
  const { organizationId } = getUser();

  return (
    <MenuItem
      tabIndex={0}
      onClick={handleChangeOrg}
      selected={orgId === organizationId}
      sx={{
        pl: 0,
        ...(organizationId === orgId && {
          backgroundColor: 'greyLight',
          pointerEvents: 'none',
        }),
      }}
    >
      {isAuthenticated && organizationId === orgId ? (
        <ListItemIcon sx={{ display: 'flex', alignItems: 'center' }}>
          <ArrowRightIcon fontSize="small" sx={{ ml: 2 }} />
          <b>{orgName}</b>
        </ListItemIcon>
      ) : (
        <ListItemText inset>{orgName}</ListItemText>
      )}
    </MenuItem>
  );
};

export default OrganizationListItem;
